import { StatelessApp } from '@katalon-studio/katalon-ui-utils';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import {
  fromAccounts, fromAuth, fromLayout,
  useAppDispatch,
} from '../../../store';
import { useLaunchDarkly } from '../../../launchdarkly';
import { renewToken } from '../../../services/keycloak';
import { usePermission } from '../../../permission';
import { useQuery, useReadOnlyMode } from '../../../routes';
import {
  reportFrontendLog,
  reportFrontendStatus,
  reportHandledError,
} from '../../../../frontendObservability';

const SubscriptionManagementPage = () => {
  const dispatch = useAppDispatch();
  const { get } = useQuery();
  const { flags } = useLaunchDarkly();
  const token = useSelector(fromAuth.selectToken);
  const selectedAccount = useSelector(fromAccounts.selectSelectedAccount);
  const { permissionMapping } = usePermission();
  const accountId = Number(get('accountId'));
  const path = `${window.location.origin}/${process.env.REACT_APP_SUBSCRIPTIONS_MANAGEMENT_MICROAPP_URL}/index.html?t=${new Date().getTime()}`;
  const isReadOnly = useReadOnlyMode();

  useEffect(() => {
    dispatch(fromLayout.setLoading(false));
  }, []);

  return (
    <StatelessApp
      id="katalon-subscription-management"
      key={`katalon-subscription-management-${accountId}`}
      path={path}
      context={{
        config: {
          ceBaseUrl: `${window.location.origin}`,
          ceApiUrl: `${process.env.REACT_APP_API_URL}`,
          accountUuid: selectedAccount?.uuid ?? '',
          k1ApiUrl: `${process.env.REACT_APP_K1_API_URL}`,
          adminUrl: `${process.env.REACT_APP_ADMIN_URL}`,
          g3Url: `${process.env.REACT_APP_TESTOPS_G3_URL}`,
          accessToken: token?.jwt,
          // subscription-ui interpolates this straight into an Authorization header;
          // it must resolve to the raw JWT string, never the {jwt, refreshJwt} pair
          getNewAccessToken: renewToken,
          stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
          isReadOnly,
        },
        ldFlags: flags,
        observability: {
          reportFrontendLog,
          reportFrontendStatus,
          reportHandledError,
        },
        permissions: permissionMapping,
      }}
    />
  );
};

export default SubscriptionManagementPage;
